import React, { type FC } from 'react';
import { Alert } from 'antd';
import { Button, Link } from '@g2u/ui-kit';

import env from 'env';

import { JsonDataItem, type WithOptionalDataTest } from 'types';
import { useCustomerNameWithLabels } from 'helpers/hooks/useCustomerNameWithLabels';
import { encryptAesToken } from 'helpers/crypto';

export namespace LegacyCustomerAlert {
  export type Props = {
    customer: JsonDataItem;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { customer } = props;
    const name = useCustomerNameWithLabels(customer);

    return (
      <Alert
        message={
          <>
            Customer: <span data-dd-privacy="mask">{name}</span>
          </>
        }
        type="info"
        showIcon
        action={
          <Link.$
            href={`${env.LEGACY_BMS_URL}customers/index/edit/id/${encryptAesToken(customer.ID.toString())}`}
            target="_blank"
          >
            <Button.$ size={Button.Size.Small} onClick={() => null} dataTestId="legacy-profile-link">
              View Details
            </Button.$>
          </Link.$>
        }
      />
    );
  };
}
